import CertificatesModal from './CertificatesModal/CertificatesModal'
import Auth from './Auth/Auth'
import Register from './Register/Register'
import SetPassword from './SetPassword/SetPassword'
import { ICertificates } from './CertificatesModal/CertificatesModal'
import CountdownTimer from './CountdownTimer/CountdownTimer'
import ProfilesModal from './ProfilesModal/ProfilesModal'
import { IProfiles } from "./ProfilesModal/ProfilesModal";

export { CertificatesModal, Auth, Register, SetPassword, CountdownTimer, ProfilesModal }
export type { ICertificates, IProfiles }
